import { CountiesApiParams, CountyState } from '../interfaces/interfaces';

async function getCounties(): Promise<any> {
	const url = `/quoteApi/v1/counties`;

	try {
		//Get Counties (counties in our service area) from our system of record (Clac DB in Azure SQL Instance for now)
		const response = await fetch(url);
		const counties = await response.json();

		return counties;
	}
	catch (error) {
		console.error('Error: Cannot get counties from QuoteService API', error);
		return false;
	}
}


/****
1) Start with a static list of counties & states -- this reduces 
	 latency by eliminating async call when app first loads
2) Make API call to Counties API and compare against static list
3) If any differences, append missing counties to countiesList
4) Note: If CapCenter has a major realty area expansion, 
				 consider updating initial static list of counties
****/

export async function getRealtyCountiesandStates() {
	const countiesListUnfiltered = await getCounties();
	if(countiesListUnfiltered === false)
		return false;

	const filteredCountiesList = countiesListUnfiltered.filter((object: CountiesApiParams) => object.IsRealtyApplied === true);
	const realtyCountyNames = filteredCountiesList.map((countyStateObject: CountiesApiParams) => countyStateObject.CountyName);
	const allStates = filteredCountiesList.map((countyStateObject: CountiesApiParams) => countyStateObject.State);

	function onlyUnique(value: any, index: number, self: any) {
		return self.indexOf(value) === index;
	}

	const realtyStateNames = allStates.filter(onlyUnique);

	return ({
		countiesWithRealty: filteredCountiesList,
		realtyCountyNames,
		realtyStateNames
	});
}

const problemCounties = [
	{
		mlsCountyName: 'Baltimore',
		capcenterCountyName: 'Baltimore County'
	},
	{
		mlsCountyName: 'Baltimore City',
		capcenterCountyName: 'Baltimore'
	},
	{
		mlsCountyName: 'Henrico County Va',
		capcenterCountyName: 'Henrico'
	},
	{
		mlsCountyName: 'Henrico County',
		capcenterCountyName: 'Henrico'
	},
	{
		mlsCountyName: 'Lynchburg City',
		capcenterCountyName: 'Lynchburg'
	},
	{
		mlsCountyName: 'Hampton Va',
		capcenterCountyName: 'Hampton'
	},
	{
		mlsCountyName: 'Saint Marys',
		capcenterCountyName: 'St. Mary\'s'
	},
];

function normalizeCountyName(countyName: string) {
	let normalizedCountyName = null;
	let matchedProblemCountyObject: any;

	problemCounties.filter((countyObject: any) => {
		if (countyObject.mlsCountyName === countyName) {
			matchedProblemCountyObject = countyObject;
		}
	});

	if (matchedProblemCountyObject) {
		normalizedCountyName = matchedProblemCountyObject.capcenterCountyName;
	} else {
		normalizedCountyName = countyName;
	}

	return normalizedCountyName;
}

export async function getMatchedCountyObject(mlsCountyName: string, mlsStateName: string) {
	const normalizedMlsCountyName = normalizeCountyName(mlsCountyName);
	const countiesList = await getCounties();
	let matchedCountyObject: any;

	if (countiesList !== false) {
		matchedCountyObject = 
			countiesList.filter((object: CountiesApiParams) => 
				object.CountyName === normalizedMlsCountyName && object.State.toLowerCase() === mlsStateName.toLowerCase());
	}

	if (matchedCountyObject.length > 0) {
		return matchedCountyObject;
	} else {
		console.error(
			`Error matching MLS CountyName to county names from /QuoteService/api/Counties
			
			*Normalized MLS county name: ${normalizedMlsCountyName}
			`
		);
		return false;
	}
}

export const stateList = [
	'VA',
	'NC',
	'SC',
	'DC',
	'MD'
];

export const countyStateList: CountyState[] = [
	{ county: 'Alamance', state: 'NC', realtyIsActive: true },
	{ county: 'Albemarle', state: 'VA', realtyIsActive: true },
	{ county: 'Alexandria', state: 'VA', realtyIsActive: true },
	{ county: 'Amelia', state: 'VA', realtyIsActive: true },
	{ county: 'Anderson', state: 'SC', realtyIsActive: true },
	{ county: 'Anne Arundel', state: 'MD', realtyIsActive: true },
	{ county: 'Anson', state: 'NC', realtyIsActive: true },
	{ county: 'Arlington', state: 'VA', realtyIsActive: true },
	{ county: 'Baltimore', state: 'MD', realtyIsActive: true },
	{ county: 'Baltimore County', state: 'MD', realtyIsActive: true },
	{ county: 'Berkeley', state: 'SC', realtyIsActive: true },
	{ county: 'Buckingham', state: 'VA', realtyIsActive: true },
	{ county: 'Cabarrus', state: 'NC', realtyIsActive: true },
	{ county: 'Calhoun', state: 'SC', realtyIsActive: true },
	{ county: 'Caroline', state: 'VA', realtyIsActive: true },
	{ county: 'Carroll', state: 'MD', realtyIsActive: true },
	{ county: 'Catawba', state: 'NC', realtyIsActive: true },
	{ county: 'Charles', state: 'MD', realtyIsActive: true },
	{ county: 'Charles City', state: 'VA', realtyIsActive: true },
	{ county: 'Charleston', state: 'SC', realtyIsActive: true },
	{ county: 'Charlottesville', state: 'VA', realtyIsActive: true },
	{ county: 'Chatham', state: 'NC', realtyIsActive: true },
	{ county: 'Cherokee', state: 'SC', realtyIsActive: true },
	{ county: 'Chesapeake', state: 'VA', realtyIsActive: true },
	{ county: 'Chesterfield', state: 'VA', realtyIsActive: true },
	{ county: 'Clarke', state: 'VA', realtyIsActive: true },
	{ county: 'Cleveland', state: 'NC', realtyIsActive: true },
	{ county: 'Colleton', state: 'SC', realtyIsActive: true },
	{ county: 'Colonial Heights', state: 'VA', realtyIsActive: true },
	{ county: 'Culpeper', state: 'VA', realtyIsActive: true },
	{ county: 'Davidson', state: 'NC', realtyIsActive: true },
	{ county: 'Davie', state: 'NC', realtyIsActive: true },
	{ county: 'Dinwiddie', state: 'VA', realtyIsActive: true },
	{ county: 'Dorchester', state: 'SC', realtyIsActive: true },
	{ county: 'Durham', state: 'NC', realtyIsActive: true },
	{ county: 'Essex', state: 'VA', realtyIsActive: true },
	{ county: 'Fairfax', state: 'VA', realtyIsActive: true },
	{ county: 'Fairfax City', state: 'VA', realtyIsActive: true },
	{ county: 'Falls Church', state: 'VA', realtyIsActive: true },
	{ county: 'Fauquier', state: 'VA', realtyIsActive: true },
	{ county: 'Fluvanna', state: 'VA', realtyIsActive: true },
	{ county: 'Forsyth', state: 'NC', realtyIsActive: true },
	{ county: 'Franklin', state: 'NC', realtyIsActive: true },
	{ county: 'Frederick', state: 'VA', realtyIsActive: true },
	{ county: 'Frederick', state: 'MD', realtyIsActive: true },
	{ county: 'Fredericksburg', state: 'VA', realtyIsActive: true },
	{ county: 'Gaston', state: 'NC', realtyIsActive: true },
	{ county: 'Gloucester', state: 'VA', realtyIsActive: true },
	{ county: 'Goochland', state: 'VA', realtyIsActive: true },
	{ county: 'Greene', state: 'VA', realtyIsActive: true },
	{ county: 'Greenville', state: 'SC', realtyIsActive: true },
	{ county: 'Guilford', state: 'NC', realtyIsActive: true },
	{ county: 'Hampton', state: 'VA', realtyIsActive: true },
	{ county: 'Hanover', state: 'VA', realtyIsActive: true },
	{ county: 'Harford', state: 'MD', realtyIsActive: true },
	{ county: 'Henrico', state: 'VA', realtyIsActive: true },
	{ county: 'Hopewell', state: 'VA', realtyIsActive: true },
	{ county: 'Howard', state: 'MD', realtyIsActive: true },
	{ county: 'Iredell', state: 'NC', realtyIsActive: true },
	{ county: 'Isle Of Wight', state: 'VA', realtyIsActive: true },
	{ county: 'James City', state: 'VA', realtyIsActive: true },
	{ county: 'Johnston', state: 'NC', realtyIsActive: true },
	{ county: 'King And Queen', state: 'VA', realtyIsActive: true },
	{ county: 'King George', state: 'VA', realtyIsActive: true },
	{ county: 'King William', state: 'VA', realtyIsActive: true },
	{ county: 'Lancaster', state: 'SC', realtyIsActive: true },
	{ county: 'Lexington', state: 'SC', realtyIsActive: true },
	{ county: 'Lincoln', state: 'NC', realtyIsActive: true },
	{ county: 'Loudoun', state: 'VA', realtyIsActive: true },
	{ county: 'Louisa', state: 'VA', realtyIsActive: true },
	{ county: 'Manassas', state: 'VA', realtyIsActive: true },
	{ county: 'Manassas Park', state: 'VA', realtyIsActive: true },
	{ county: 'Mecklenburg', state: 'NC', realtyIsActive: true },
	{ county: 'Middlesex', state: 'VA', realtyIsActive: true },
	{ county: 'Montgomery', state: 'MD', realtyIsActive: true },
	{ county: 'Nelson', state: 'VA', realtyIsActive: true },
	{ county: 'New Kent', state: 'VA', realtyIsActive: true },
	{ county: 'Newport News', state: 'VA', realtyIsActive: true },
	{ county: 'Norfolk', state: 'VA', realtyIsActive: true },
	{ county: 'Oconee', state: 'SC', realtyIsActive: true },
	{ county: 'Orange', state: 'VA', realtyIsActive: true },
	{ county: 'Orange', state: 'NC', realtyIsActive: true },
	{ county: 'Petersburg', state: 'VA', realtyIsActive: true },
	{ county: 'Pickens', state: 'SC', realtyIsActive: true },
	{ county: 'Poquoson', state: 'VA', realtyIsActive: true },
	{ county: 'Portsmouth', state: 'VA', realtyIsActive: true },
	{ county: 'Powhatan', state: 'VA', realtyIsActive: true },
	{ county: 'Prince George', state: 'VA', realtyIsActive: true },
	{ county: 'Prince George\'s', state: 'MD', realtyIsActive: true },
	{ county: 'Prince William', state: 'VA', realtyIsActive: true },
	{ county: 'Randolph', state: 'NC', realtyIsActive: true },
	{ county: 'Rappahannock', state: 'VA', realtyIsActive: true },
	{ county: 'Richland', state: 'SC', realtyIsActive: true },
	{ county: 'Richmond City', state: 'VA', realtyIsActive: true },
	{ county: 'Rowan', state: 'NC', realtyIsActive: true },
	{ county: 'Southampton', state: 'VA', realtyIsActive: true },
	{ county: 'Spartanburg', state: 'SC', realtyIsActive: true },
	{ county: 'Spotsylvania', state: 'VA', realtyIsActive: true },
	{ county: 'Stafford', state: 'VA', realtyIsActive: true },
	{ county: 'Stanly', state: 'NC', realtyIsActive: true },
	{ county: 'Stokes', state: 'NC', realtyIsActive: true },
	{ county: 'Suffolk', state: 'VA', realtyIsActive: true },
	{ county: 'Union', state: 'NC', realtyIsActive: true },
	{ county: 'Virginia Beach', state: 'VA', realtyIsActive: true },
	{ county: 'Wake', state: 'NC', realtyIsActive: true },
	{ county: 'Warren', state: 'VA', realtyIsActive: true },
	{ county: 'Washington', state: 'DC', realtyIsActive: true },
	{ county: 'Williamsburg', state: 'VA', realtyIsActive: true },
	{ county: 'Winchester', state: 'VA', realtyIsActive: true },
	{ county: 'Yadkin', state: 'NC', realtyIsActive: true },
	{ county: 'York', state: 'VA', realtyIsActive: true },
	{ county: 'York', state: 'SC', realtyIsActive: true }
];


